import { DatePickerProps } from "antd";
import { Dayjs } from "dayjs";

const cellRender: DatePickerProps<Dayjs>["cellRender"] = (current, info) => {
  if (info.type !== "date") {
    return info.originNode;
  }
  if (typeof current === "string" || typeof current === "number") {
    return <div className="bg-font-active!">{current}</div>;
  }
  return (
    <span
      className="ant-picker-cell-inner before:rounded-full! select-none"
      style={{
        borderRadius: "50%",
        padding: "15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        aspectRatio: 1,
      }}
    >
      {current.date()}
    </span>
  );
};


export { cellRender };